module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "chapter19"
    }
  }, [_c('h1', [_c('a', {
    attrs: {
      "id": "page_37"
    }
  }), _c('a', {
    attrs: {
      "href": "#/003toc#ch19"
    }
  }, [_vm._v("Monterey Bay Bean Soup")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("This is a favorite soup with my students. It goes together in 5 minutes, and at the end of the day you have a hearty vegetarian main course. Don’t let the chiles scare you away; they are there for flavor and not heat!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('sup', [_vm._v("1")]), _vm._v("/"), _c('sub', [_vm._v("3")]), _vm._v(" cup vegetable oil")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("1 large onion, finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("1 clove garlic, minced")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("4 Anaheim chiles, seeded and chopped")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("1½ teaspoons chili powder")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("One 14- to 15-ounce can chopped tomatoes, drained")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Two 14- to 15-ounce cans pinto beans, drained and rinsed")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("6 cups chicken broth")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("2 cups cooked chorizo sausage, crumbled (optional)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Salt and freshly ground black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("2 cups broken fried tortilla strips")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("½ cup shredded mild Cheddar or Monterey")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Jack cheese")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("½ cup sour cream for garnishing")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("4 green onions, chopped, using the white and tender green parts for garnishing")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("½ cup finely minced fresh cilantro for garnishing")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("heat the oil in a large skillet over medium heat. Add the onion, garlic, and chiles and sauté until the vegetables are softened, about 5 minutes. Stir in the chili powder and cook, stirring, for about 1 minute, until fragrant.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("transfer the contents of the skillet to the insert of a 5- to 7-quart slow cooker. Add the tomatoes, beans, broth, and sausage (if using).")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("cover the slow cooker and cook the soup on high for 3 to 4 hours or on low for 7 to 8 hours.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("season with salt and pepper. Add the tortilla strips to the soup, cover, and let stand for 10 minutes, until the strips just begin to soften.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("divide the cheese among 8 bowls and ladle the soup over.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Garnish each serving with a dollop of sour cream, chopped green onion, and minced cilantro.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("serves 8")])]), _vm._v(" "), _c('p', {
    staticClass: "breakhere"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7974c14e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/025-chapter19.vue
// module id = 129
// module chunks = 0